import 'lib-flexible/flexible'
import 'vant/lib/index.css';
import attachFastClick from 'fastclick';
import Vant from 'vant';
import Vue from 'vue'
import App from './App.vue'
import common from './common';
import i18n from './i18n';
import router from './router'
import store from './store'
Vue.prototype.$common = common
import { $fetch, $post, $put, $del } from './http'
import Bridge from './config/bridge'
import { setStorage, getStorage, invokeApp, getQueryString, } from '@/util'
import Vue2TouchEvents from 'vue2-touch-events'
Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(Vue2TouchEvents, {
    disableClick: true,
});
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})
// router.afterEach((to, from, next) => {
//     gtag('config', window['GAID'], { 'page_path': to.fullPath });
//     window.gtag('set', 'page', to.fullPath)
//     window.gtag('send', 'pageview')
// })
//请求
//全局注册和ios的交互
Vue.prototype.$bridge = Bridge
Vue.prototype.$getStorage = getStorage
//全局注册请求方法
Vue.prototype.$fetch = $fetch
Vue.prototype.$post = $post
Vue.prototype.$put = $put
Vue.prototype.$del = $del
// fastClick
attachFastClick.attach(document.body);
// resetcss
import '@/common/styl/reset.styl'
import '@/assets/css/common.css'
try {
    setStorage('inApp', true);
    common.inApp = true;
    invokeApp('getVersion', function(appversion) {})
} catch (err) {
    setStorage('inApp', false);
    common.inApp = false;
}

if (common.inApp) {
    invokeApp('getAccessToken', function(access_token) {
		setStorage('access_token', access_token);
		common.accessToken = access_token;
		invokeApp('getLang', function(lang) {
			setStorage('lang', lang);
			common.lang = lang;
			i18n.locale = lang;
			invokeApp('getVersion', function(appversion) {
				setStorage('appversion', appversion)
				common.appversion = appversion;
				new Vue({ router, store, i18n, render: h => h(App) }).$mount('#app')
			})
		});
    });
} else {
    new Vue({ router, store, i18n, render: h => h(App) }).$mount('#app')
}